// extracted by mini-css-extract-plugin
export default {"empty":"empty-de2xA","emptyNoBg":"empty-no-bg-_SsnW","emptyWrap":"empty-wrap-KaX7S","emptyWrapMango":"empty-wrap-mango-_AqJh"};